



































































import { Component, Prop, Mixins } from 'vue-property-decorator';
import { Infoblock, Miniheader } from './components';
import { Picture } from '@/pages/profile/blocks/cards/components';
import { Button, Accordion } from '@/pages/profile/components';
import { RouteParsedMixin } from '@/pages/profile/mixins';
import { Contract, IContractCard, StatusType } from './types';

@Component({
  components: {
    Picture,
    Button,
    Accordion,
    Infoblock,
    Miniheader,
  },
})
export default class ContractCard extends Mixins(RouteParsedMixin)
  implements IContractCard {
  @Prop({ type: Object, required: true })
  readonly item!: Contract;

  @Prop({ type: String, default: '' })
  readonly fio!: string;

  @Prop({ type: Number, default: 0 })
  readonly index!: number;

  opened: boolean = false;

  get eventLink(): string {
    return this.item.event_id ? `/program/${this.item.event_id}` : '';
  }

  get groupLink(): string {
    return this.item.group_id
      ? `/program/${this.item.event_id}_group-${this.item.group_id}`
      : '';
  }

  get partnerLink(): string {
    return this.item.partner_id ? `/organization/${this.item.partner_id}` : '';
  }

  get status(): StatusType {
    switch (this.item.status) {
      case 'completed':
        return {
          text: 'Исполненный',
          color: 'blue',
        };
        break;

      case 'unrealized':
        return {
          text: 'Нереализованный',
          color: 'purple',
        };
        break;

      case 'terminated':
        return {
          text: 'Расторгнутый',
          color: 'red',
        };
        break;

      case 'pending':
        return {
          text: 'Приостановленный',
          color: 'maroon',
        };
        break;

      case 'active':
        return {
          text: 'Действующий',
          color: 'green',
        };
        break;

      default:
        return {
          text: 'Ожидает подписания',
          color: 'grey',
        };
        break;
    }
  }

  toggle(): void {
    this.opened = !this.opened;
  }

  download(): void {
    window.open(`/${this.item.download_link}`, '_blank');
  }

  assign(): void {
    this.$emit('assign', this.index);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/blocks/cards/contract/Contract.vue